export const MONTHS = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre'
];

export const DAYS = {
  MONDAY: 'Lun',
  SUNDAY: 'Dom',
  SATURDAY: 'Sab',
  FRIDAY: 'Vie',
  THURSDAY: 'Jue',
  WEDNESDAY: 'Mie',
  TUESDAY: 'Mar'
};
